import React from 'react';
import {useFormikContext} from 'formik';
import {TextField} from '@mui/material';
import Card from '@mui/material/Card';

const getDisplayValue = (value) => {
  if (!value) return '';
  if (typeof value === 'object') {
    return value?.name || value?.code || '';
  }
  return value;
};

export default function ConservationEntryOne() {
  const {values} = useFormikContext();
  return (
    <div>
      <Card className={'box-shadow'} sx={{p: 4, paddingBottom: 12}}>
        <TextField variant={'outlined'} size={'small'} fullWidth label={'Accession No.'}
               value={getDisplayValue(values?.accession_no)} disabled
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <TextField variant={'outlined'} size={'small'} fullWidth label={'Classification'}
               value={getDisplayValue(values?.object_group)} disabled
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <TextField variant={'outlined'} size={'small'} fullWidth label={'Object Name'}
               value={values?.object_name || ''} disabled
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <TextField variant={'outlined'} size={'small'} fullWidth label={'Materials'}
               value={getDisplayValue(values?.material)} disabled
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
      </Card>
    </div>
  );
}